export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  categorySlug: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: ComicChapter[];
  updatedAt: string;
  createdAt: string;
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '韩漫', slug: 'korean' },
  { name: '日漫', slug: 'japanese' },
  { name: '国漫', slug: 'chinese' },
  { name: '耽美', slug: 'danmei' },
  { name: '玄幻', slug: 'xuanhuan' },
  { name: '都市', slug: 'urban' },
  { name: '搞笑', slug: 'comedy' },
  { name: '悬疑', slug: 'mystery' },
  { name: '恋爱', slug: 'romance' },
  { name: '动作', slug: 'action' },
  { name: '奇幻', slug: 'fantasy' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '剑尊归来',
    author: 'Redice Studio',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20manhwa%20style%20cover%20art%20featuring%20a%20powerful%20swordsman%20in%20traditional%20martial%20arts%20robe%20with%20flowing%20long%20black%20hair%2C%20holding%20a%20glowing%20sword%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20red%20tones%2C%20dynamic%20action%20pose%2C%20manga%20illustration%20style%2C%20clean%20soft%20gradient%20background%20with%20subtle%20cherry%20blossom%20petals&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '曾经被誉为天下第一剑的独孤寒，在遭到背叛后坠入悬崖。百年之后，他意外重生在一个弱小少年的身上。这一世，他将以全新的身份，重拾剑道，向昔日的仇人展开复仇！华丽的剑术对决，错综复杂的江湖恩怨，一部酣畅淋漓的武侠玄幻巨作！',
    category: '韩漫',
    categorySlug: 'korean',
    tags: ['玄幻', '武侠', '重生', '复仇'],
    status: '连载中',
    rating: 9.6,
    views: 1280000,
    chapters: Array.from({ length: 87 }, (_, i) => ({
      id: `ch-1-${i + 1}`,
      title: `第${i + 1}话 ${['序幕：剑尊陨落', '重生之日', '初入剑道', '试炼之路', '突破瓶颈'][i % 5]}${i > 4 ? ` (续)` : ''}`,
      number: i + 1,
      updatedAt: `2026-0${8 - Math.floor(i / 30)}-${String(30 - (i % 30)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-03',
    createdAt: '2025-03-15',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-2',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cool%20manhwa%20cover%20featuring%20a%20lone%20hunter%20in%20dark%20modern%20combat%20gear%20with%20a%20mysterious%20shadow%20army%20behind%20him%2C%20dark%20atmospheric%20city%20in%20the%20background%2C%20purple%20and%20black%20color%20scheme%20with%20glowing%20blue%20eyes%2C%20intense%20stare%2C%20manga%20illustration%20style%2C%20minimalist%20composition&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '在一个突然出现神秘传送门的世界里，人类被分为了猎人和普通人。成肖宇，被誉为人类最弱的E级猎人。在一次几乎全军覆没的地下城探险中，他意外获得了独一无二的升级系统。从此，从最弱到最强，他独自踏上了升级之路！',
    category: '韩漫',
    categorySlug: 'korean',
    tags: ['奇幻', '战斗', '系统流', '升级'],
    status: '已完结',
    rating: 9.8,
    views: 2560000,
    chapters: Array.from({ length: 179 }, (_, i) => ({
      id: `ch-2-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${8 - Math.floor(i / 60)}-${String(28 - (i % 28)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-07-28',
    createdAt: '2024-08-01',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-3',
    title: '全知读者视角',
    author: 'Sing Shong / Sleepy-C',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20manhwa%20cover%20showing%20a%20young%20office%20worker%20transformed%20into%20a%20survival%20game%20protagonist%2C%20holding%20a%20glowing%20book%2C%20apocalyptic%20fantasy%20world%20behind%20him%20with%20ruins%20and%20monsters%2C%20warm%20golden%20and%20brown%20tones%2C%20manga%20illustration%20style%2C%20dramatic%20composition&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '金独子是一个普通的上班族，唯一的爱好就是阅读一部连载了十年的网络小说。当这部小说终于完结的那一天，小说中的世界竟然变成了现实。作为唯一的读者，他成为了这个末日世界中唯一知晓剧情走向的人。在这场生存游戏中，他能活到最后吗？',
    category: '韩漫',
    categorySlug: 'korean',
    tags: ['奇幻', '生存', '系统流', '末世'],
    status: '连载中',
    rating: 9.7,
    views: 1890000,
    chapters: Array.from({ length: 210 }, (_, i) => ({
      id: `ch-3-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${8 - Math.floor(i / 70)}-${String(25 - (i % 25)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-02',
    createdAt: '2024-11-20',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-4',
    title: '咒术回战',
    author: '芥见下下',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20shonen%20manga%20cover%20featuring%20a%20spiky%20haired%20teenager%20with%20supernatural%20cursed%20energy%20surrounding%20his%20fists%2C%20urban%20Tokyo%20skyline%20at%20night%20in%20the%20background%2C%20vibrant%20red%20and%20dark%20blue%20energy%20effects%2C%20action%20pose%2C%20Japanese%20manga%20style%2C%20bold%20lineart&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '高中生虎杖悠仁在偶然的机会下吞下了诅咒之王两面宿傩的手指，从此被卷入了咒术师与诅咒之间的战斗。为了拯救更多人，他加入了东京都立咒术高等专门学校，开始了与诅咒对抗的冒险。一场关乎人类命运的咒术大战即将展开！',
    category: '日漫',
    categorySlug: 'japanese',
    tags: ['战斗', '奇幻', '热血', '校园'],
    status: '连载中',
    rating: 9.5,
    views: 3100000,
    chapters: Array.from({ length: 263 }, (_, i) => ({
      id: `ch-4-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${8 - Math.floor(i / 80)}-${String(22 - (i % 22)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-01',
    createdAt: '2022-03-05',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-5',
    title: '一人之下',
    author: '米二',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20a%20mysterious%20young%20man%20with%20traditional%20Taoist%20robe%2C%20surrounded%20by%20glowing%20talismans%20and%20martial%20arts%20qi%20energy%2C%20traditional%20Chinese%20landscape%20with%20mountains%20and%20pine%20trees%20in%20the%20background%2C%20warm%20earthy%20tones%2C%20Chinese%20manhua%20illustration%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '普通大学生张楚岚在爷爷的坟墓被盗后，意外卷入了异人的世界。在这个隐藏在现代社会背后的江湖中，各路奇人异士齐聚一堂。从不入流的菜鸟到叱咤风云的强者，张楚岚的成长之路充满了笑料与热血。冯宝宝的身世之谜，三十六贼的往事，这一切都指向了一个惊天秘密！',
    category: '国漫',
    categorySlug: 'chinese',
    tags: ['玄幻', '都市', '热血', '搞笑'],
    status: '连载中',
    rating: 9.4,
    views: 5600000,
    chapters: Array.from({ length: 680 }, (_, i) => ({
      id: `ch-5-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${8 - Math.floor(i / 200)}-${String(20 - (i % 20)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-03',
    createdAt: '2020-06-15',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-6',
    title: '星梦偶像计划',
    author: '烟头',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sparkling%20idol%20themed%20manhua%20cover%20with%20a%20beautiful%20girl%20on%20stage%20in%20glittering%20performance%20costume%2C%20spotlight%20effects%2C%20stage%20with%20colorful%20lights%2C%20pop%20star%20atmosphere%2C%20dreamy%20pink%20and%20golden%20tones%2C%20Chinese%20manhua%20style%2C%20glamorous%20and%20inspiring%20composition&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '热爱舞台的普通女孩顾星漫，凭借对音乐的热爱和不懈的努力，在一场全国偶像选拔中脱颖而出。从默默无闻到万众瞩目，她将面对激烈的竞争、团队的磨合以及内心的挣扎。这是一个关于梦想、友情和成长的闪耀故事！',
    category: '国漫',
    categorySlug: 'chinese',
    tags: ['偶像', '励志', '恋爱', '音乐'],
    status: '连载中',
    rating: 9.2,
    views: 890000,
    chapters: Array.from({ length: 156 }, (_, i) => ({
      id: `ch-6-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${8 - Math.floor(i / 50)}-${String(18 - (i % 18)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-07-30',
    createdAt: '2023-01-10',
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-7',
    title: '反派初始化',
    author: 'CuZn',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20showing%20a%20stylish%20anti-hero%20character%20in%20modern%20fashionable%20clothing%20with%20a%20smirk%2C%20holding%20a%20digital%20tablet%2C%20futuristic%20holographic%20interface%20around%20him%2C%20urban%20cityscape%20at%20dusk%2C%20cool%20teal%20and%20orange%20accent%20tones%2C%20Chinese%20manhua%20style&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '凌逸穿越到了一个漫画世界，成为了注定要被主角打败的反派角色。但他可不想按照剧本走，凭借对剧情的了解和对现代科技的应用，他决定改写自己的命运。谁说反派就一定要输？看凌逸如何用商业头脑和超前知识，在这个世界翻云覆雨！',
    category: '国漫',
    categorySlug: 'chinese',
    tags: ['穿越', '都市', '商战', '逆袭'],
    status: '连载中',
    rating: 9.3,
    views: 1560000,
    chapters: Array.from({ length: 198 }, (_, i) => ({
      id: `ch-7-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${8 - Math.floor(i / 60)}-${String(16 - (i % 16)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-02',
    createdAt: '2023-06-20',
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-8',
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20cover%20with%20a%20young%20demon%20slayer%20wielding%20a%20nichirin%20blade%2C%20wearing%20traditional%20checkered%20haori%2C%20water%20breathing%20technique%20visual%20effects%20with%20flowing%20waves%2C%20traditional%20Japanese%20mountain%20scenery%20at%20dawn%2C%20warm%20red%20and%20blue%20tones%2C%20classic%20manga%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '大正时代的日本，少年灶门炭治郎全家被鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复人类的方法，炭治郎踏上了成为鬼杀队剑士的道路。在残酷的战斗与温暖的羁绊中，一个关于家人与复仇的感人故事徐徐展开。',
    category: '日漫',
    categorySlug: 'japanese',
    tags: ['战斗', '奇幻', '热血', '感人'],
    status: '已完结',
    rating: 9.7,
    views: 4200000,
    chapters: Array.from({ length: 205 }, (_, i) => ({
      id: `ch-8-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2025-${String(12 - Math.floor(i / 30)).padStart(2, '0')}-${String(28 - (i % 28)).padStart(2, '0')}`,
    })),
    updatedAt: '2025-10-15',
    createdAt: '2021-02-15',
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-9',
    title: '绝世战魂',
    author: '天蚕土豆 / 任翔',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20a%20young%20martial%20artist%20cultivating%20in%20a%20fantasy%20world%2C%20surrounded%20by%20spiritual%20energy%20and%20golden%20dragons%2C%20ancient%20Chinese%20palace%20in%20the%20misty%20background%2C%20epic%20scale%2C%20warm%20golden%20and%20jade%20green%20tones%2C%20Chinese%20manhua%20style&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '少年秦南天生废脉，无法修炼。在偶然获得一枚神秘古戒后，他的命运从此改变。绝世功法、逆天战技，一切尽在掌握。从一个被人嘲笑的废物，到叱咤风云的绝世强者。这天下，终将为他而颤抖！',
    category: '国漫',
    categorySlug: 'chinese',
    tags: ['玄幻', '武侠', '逆袭', '热血'],
    status: '连载中',
    rating: 9.0,
    views: 2300000,
    chapters: Array.from({ length: 520 }, (_, i) => ({
      id: `ch-9-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${8 - Math.floor(i / 170)}-${String(14 - (i % 14)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-01',
    createdAt: '2022-09-01',
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-10',
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20romantic%20fantasy%20manhwa%20cover%20featuring%20a%20princess%20in%20an%20elegant%20vintage%20European%20style%20gown%2C%20standing%20in%20a%20royal%20palace%20garden%20with%20blooming%20roses%2C%20soft%20golden%20sunlight%2C%20dreamy%20pastel%20pink%20and%20cream%20tones%2C%20romantic%20shojo%20manga%20style&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '一个普通女孩穿越成为了小说中的公主雅典娜，但问题是——她是一个注定要被父皇处死的悲剧公主！为了活下去，她必须用尽一切方法获得冷酷父皇的喜爱。从练习可爱笑容到用心机计谋，看她如何在这个危险的皇宫中生存下来，并收获意想不到的爱情！',
    category: '韩漫',
    categorySlug: 'korean',
    tags: ['恋爱', '穿越', '宫廷', '喜剧'],
    status: '连载中',
    rating: 9.5,
    views: 1750000,
    chapters: Array.from({ length: 145 }, (_, i) => ({
      id: `ch-10-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${8 - Math.floor(i / 45)}-${String(12 - (i % 12)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-03',
    createdAt: '2023-04-10',
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-11',
    title: '进击的巨人',
    author: '谏山创',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20epic%20manga%20cover%20showing%20a%20gigantic%20titan%20looming%20over%20massive%20protective%20walls%2C%20soldiers%20with%20vertical%20maneuvering%20equipment%20swinging%20through%20the%20air%2C%20apocalyptic%20atmosphere%2C%20grim%20brown%20and%20dark%20red%20tones%2C%20Japanese%20manga%20style%2C%20cinematic%20composition&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '在一个被巨大城墙包围的世界里，人类在墙内过着相对和平的生活。然而，某一天，超大型巨人突然出现，打破了这层宁静。艾伦·耶格尔目睹母亲被巨人吞噬，从此立下誓言要消灭所有巨人。随着墙外世界的秘密被揭开，一场关于自由与命运的壮丽史诗就此展开！',
    category: '日漫',
    categorySlug: 'japanese',
    tags: ['战斗', '黑暗', '悬疑', '史诗'],
    status: '已完结',
    rating: 9.6,
    views: 3800000,
    chapters: Array.from({ length: 139 }, (_, i) => ({
      id: `ch-11-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2023-${String(12 - Math.floor(i / 20)).padStart(2, '0')}-${String(30 - (i % 30)).padStart(2, '0')}`,
    })),
    updatedAt: '2023-04-09',
    createdAt: '2019-09-09',
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-12',
    title: '间谍过家家',
    author: '远藤达哉',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20wholesome%20and%20funny%20manga%20cover%20featuring%20a%20family%20of%20three%20dressed%20elegantly%20in%20formal%20attire%2C%20the%20father%20as%20a%20suave%20spy%2C%20mother%20as%20an%20assassin%20and%20a%20cute%20little%20girl%20with%20pink%20hair%20holding%20a%20toy%2C%20warm%20family%20atmosphere%2C%20soft%20cream%20and%20pastel%20green%20tones%2C%20Japanese%20manga%20style&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '为了执行秘密任务，顶级间谍黄昏需要组建一个临时家庭。他收养了能读心的超能力女孩阿尼亚，又和杀手约尔假结婚。三人各怀秘密，却在日常相处中产生了真实的羁绊。一部温馨搞笑又充满动作元素的家庭喜剧！',
    category: '日漫',
    categorySlug: 'japanese',
    tags: ['搞笑', '家庭', '间谍', '温馨'],
    status: '连载中',
    rating: 9.5,
    views: 2900000,
    chapters: Array.from({ length: 98 }, (_, i) => ({
      id: `ch-12-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${8 - Math.floor(i / 30)}-${String(10 - (i % 10)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-02',
    createdAt: '2022-01-15',
    isHot: false,
    isNew: true,
  },
];

export const hotComics = comics.filter((c) => c.isHot);
export const newComics = comics.filter((c) => c.isNew);
export const completedComics = comics.filter((c) => c.status === '已完结');

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(slug: string): Comic[] {
  if (slug === 'all') return comics;
  return comics.filter((c) => c.categorySlug === slug);
}

export function getRelatedComics(comic: Comic, limit: number = 4): Comic[] {
  return comics
    .filter((c) => c.id !== comic.id && (c.categorySlug === comic.categorySlug || c.tags.some((t) => comic.tags.includes(t))))
    .slice(0, limit);
}